import {
  DocumentsContextProvider,
  omit,
  useDocumentsData,
  useGridSelect,
} from 'app/features/documents';
import { GridDocumentRow } from 'app/features/documents/DocumentRow';
import DocumentsFilters from 'app/features/documents/DocumentsFilters';
import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import {
  IDirectoryNode,
  useDirectoryNodeFormMutation,
} from 'app/services/documents';
import Button from 'Components/Buttons/Button';
import CheckboxInput from 'Components/Form/Inputs/CheckboxInput';
import { Grid } from 'Components/Grid';
import { sortedUniq, uniqBy } from 'lodash';
import { QuestionnaireDocument } from '.';
export function SelectPreviouslyUploadedDocuments({
  value,
  onChange,
  projectId,
}: {
  projectId: number;
  value: QuestionnaireDocument[];
  onChange: (v: QuestionnaireDocument[]) => void;
}) {
  const data = useDocumentsData(
    {},
    {
      filters: {
        mine: true,
      },
      per_page: 20,
    },
    true,
  );
  const GridSelect = useGridSelect(
    data.data,
    (d) => d.object_type === 'document' && !!d.file_url,
  );
  const [UpdateDocument, { isLoading: isUpdatingDocument }] =
    useDirectoryNodeFormMutation();
  const {
    data: nodes,
    filters,
    Pagination,
    setFilters,
    isLoading,
    directory,
  } = data;
  const popupFilters = omit('search', filters);
  const onSubmit = () => {
    const list = Object.values(GridSelect.selected);
    const promises = list.map((d) =>
      UpdateDocument({
        id: d.id,
        project_ids: Array.from(
          new Set([projectId, ...(d.projects || []).map((p) => p.id)]),
        ),
      }).unwrap(),
    );
    Promise.allSettled(promises).then((results) => {
      const success = results
        .filter((m) => m.status === 'fulfilled')
        .map((m) => (m.status === 'fulfilled' ? m.value! : undefined))
        .map((d) => d!)
        .map((d) => ({
          id: d.id,
          title: d.title,
          url: d.file_url,
        }));
      onChange(success);
      GridSelect.unselectAll();
    });
  };
  return (
    <ScrollContainer>
      <ScrollContainer className="overflow-hidden border border-gray-light-10 rounded-xl shadow">
        <DocumentsContextProvider
          {...{
            ...GridSelect,
            ...data,
          }}
        >
          <Grid
            headerClassName="bg-[#fcfcfc] shadow  py-1 overflow-hidden text-gray-dark"
            columns={[
              {
                render: (
                  <CheckboxInput
                    checked={GridSelect.isAllSelected}
                    onChange={GridSelect.selectUnselectPage}
                  />
                ),
                className: 'py-1 ',
                width: '40px',
              },
              {
                className: 'py-1 ',
                render: (
                  <div className="flex justify-between  items-center">
                    <div className="flex gap-2 items-center">
                      <Button
                        theme="red-outline"
                        disabled={GridSelect.selectedCount === 0}
                        onClick={GridSelect.unselectAll}
                      >
                        {GridSelect.selectedCount} selected
                      </Button>
                    </div>
                    <div className="flex gap-2 items-center">
                      <DocumentsFilters
                        directory={directory}
                        value={popupFilters}
                        onChange={(newFiltersValues) =>
                          setFilters({ ...filters, ...newFiltersValues })
                        }
                      />
                      <Button
                        onClick={onSubmit}
                        type="submit"
                        isLoading={isUpdatingDocument}
                        form="upload-form"
                        className="max-w-[144px]"
                        theme="green-fill"
                        disabled={GridSelect.selectedCount === 0}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                ),
                width: '1fr',
              },
            ]}
            data={nodes}
            isLoading={isLoading}
            gridRowWrap={false}
            footer={<Pagination />}
            firstRow={
              filters.id &&
              directory && (
                <GridDocumentRow
                  minimal={true}
                  rowType="Back"
                  node={directory}
                />
              )
            }
          >
            {(node) => <GridDocumentRow minimal={true} node={node} />}
          </Grid>
        </DocumentsContextProvider>
      </ScrollContainer>
    </ScrollContainer>
  );
}
